<template>
    <div class="bot-form-rt wid">
        <div class="form-rt-head">
            <div class="form-rt-nav"
                 :class="{'active': index === nowTab}"
                 @click="setNowTab(index)"
                 v-for="(tab, index) in tabs" :key="tab">{{tab}}
            </div>
            <div class="form-rt-nav timeS" v-if="nowTab === 2 || nowTab === 3">
                <el-date-picker
                        v-model="times"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
                <button class="queryBtn" @click="loading = true;getTabData()">查询</button>
            </div>
        </div>
        <div class="form-rt-body"
             v-loading="loading"
             element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
            <div class="form-rt-subhead wid"
                 :style="{'min-width': getMiniWidth() + 'px'}">
                <div class="subhead-nav"
                     :class="{'w': tag.length === 3}"
                     v-for="tag in tags[nowTab]" :key="tag[1]">{{tag[0]}}
                </div>
            </div>
            <template v-if="nowTab !== 4">
                <div class="form-rt-neir wid"
                     :style="{'min-width': getMiniWidth() + 'px'}"
                     v-for="item in datas" :key="item.id">
                    <div class="neir-nav"
                         @click="setNowFoucsDetail(item.stock_code)"
                         :class="getCLass(item[tag[1]], tag[1], tag.length)"
                         v-for="tag in tags[nowTab]" :key="tag[1]">
                        {{$globle.itemValue(item[tag[1]], tag[1])}}
                    </div>
                </div>
            </template>
            <template v-if="nowTab === 4">
                <div class="form-rt-neir"
                     :style="{'min-width': getMiniWidth() + 'px'}">
                    <div class="neir-nav"
                         v-for="tag in tags[nowTab]"
                         :class="{'w': tag.length === 3}"
                         :key="tag[1]">
                        <template v-if="tag[1] === 'accont'">
                            {{trade_account}}
                        </template>
                        <template v-else>
                            {{account_info[tag[1]]}}
                        </template>
                    </div>
                </div>
            </template>
        </div>

    </div>
</template>

<script>
    /**
     * 查询
     */
    export default {
        name: "BaseFooterQuery",
        data() {
            return {
                tabs: Object.freeze(['当日委托', '当日成交', '历史委托', '历史成交', '资产']),
                nowTab: 0,
                tags: Object.freeze([
                    this.$globle.chedanstrategyLogTag,
                    this.$globle.historyTag,
                    this.$globle.chedanstrategyLogTag,
                    this.$globle.historyTag,
                    this.$globle.accountinfoTag,
                    this.$globle.zijinliushui
                ]),
                datas: null,
                loading: true,
                times: ''
            }
        },
        created() {
            this.loading = true;
            this.datas = [];
            this.getTabData();
        },
        computed: {
            account_info: function () {
                return this.$store.state.account_info;
            },
            token: function () {
                return this.$store.state.now_token;
            },
            trade_account: function () {
                return this.$store.state.now_trade_account;
            }
        },
        watch: {
            token: function () {
                this.getTabData();
            }
        },
        methods: {
            setNowFoucsDetail(code) {
                this.$store.commit('SET_FOUCS_GP', code);
                this.$store.commit('SCROLL_TO_ITEM');
            },
            setNowTab(tab) {
                this.loading = true;
                this.nowTab = tab;
                this.datas = [];
                this.getTabData();
            },
            todayentrust() {
                this.$api.todayentrust(this.token, this.trade_account).then(res => {
                    if (res.data.code === 200) {
                        this.datas = res.data.data;
                    } else {
                        this.datas = []
                    }
                    this.loading = false;
                }).catch(() => this.loading = false)
            },
            allentrust() {
                let begin_time = this.times !== '' ? new Date(this.times[0]).format('yyyy-MM-dd') : null;
                let end_time = this.times !== '' ? new Date(this.times[1]).format('yyyy-MM-dd') : null;
                this.$api.allentrust(this.token, this.trade_account, begin_time, end_time).then(res => {
                    if (res.data.code === 200) {
                        this.datas = res.data.data;
                    } else {
                        this.datas = []
                    }
                    this.loading = false;
                }).catch(() => this.loading = false)
            },
            checkstrategyhistory(today) {
                let begin_time, end_time;
                if (today) {
                    begin_time = today ? new Date().format('yyyy-MM-dd') : null;
                    end_time = today ? new Date().format('yyyy-MM-dd') : null;
                } else {
                    begin_time = this.times !== '' ? new Date(this.times[0]).format('yyyy-MM-dd') : null;
                    end_time = this.times !== '' ? new Date(this.times[1]).format('yyyy-MM-dd') : null;
                }

                this.$api.checkstrategyhistory(this.token, this.trade_account, begin_time, end_time).then(res => {
                    if (res.data.code === 200) {
                        this.datas = res.data.data;
                    } else {
                        this.datas = []
                    }
                    this.loading = false;
                }).catch(() => this.loading = false)
            },
            getTabData() {
                if (this.nowTab === 0) {
                    this.todayentrust();
                }
                if (this.nowTab === 1) {
                    this.checkstrategyhistory(true);
                }
                if (this.nowTab === 2) {
                    this.allentrust();
                }
                if (this.nowTab === 3) {
                    this.checkstrategyhistory(false);
                }
                if (this.nowTab === 4) {
                    this.loading = false;
                    this.$store.commit('UPDATE_ACCOUNT_INFO');
                }
                if (this.nowTab === 5) {
                    this.loading = false;
                }
                if (this.nowTab === 6) {
                    this.loading = false;
                }
            },
            getCLass(value, tag, len) {
                return {
                    'w': len === 3,
                    'red': tag === 'status' && +value === 2,
                    'green': tag === 'status' && +value === 1
                }
            },
            getBigTdNum(nowTab) {
                switch (nowTab) {
                    case 0:
                    case 2:
                        return 3;
                    case 1:
                    case 3:
                        return 2;
                    default:
                        return 0;
                }
            },
            // 自动计算表格的宽度
            getMiniWidth() {
                let wCount = 0;
                this.tags[this.nowTab].map(v => {
                    if (v.length === 3) {
                        wCount++;
                    }
                });
                return 119 * this.tags[this.nowTab].length + 82 * wCount
            }
        }
    }
</script>

<style scoped lang="scss">
    .form-rt-body {
        height: calc(100% - 32px);
    }

    .form-rt-subhead {
        top: 0;
    }

    .el-input__inner {
        height: 100%;
    }

    button.queryBtn {
        padding: 4px 10px;
        border: 0;
        background: #008fff;
        border-radius: 4px;
        margin-left: 10px;
        color: #ffffff;
    }

</style>
